import { ButtonProps } from "@mui/material"

import * as Styled from "./L2RButton.styled"

type L2RButtonProps = {
    className?: string
    variant?: "primary" | "secondary" | "tertiary" | "text" | "dark"
    size?: "small" | "medium" | "large"
    shape?: "rounded" | "square" | "circle",
    disabled?: boolean
    outlined?: boolean
    children?: React.ReactNode
} & Omit<ButtonProps, "variant" | "size" | "disabled" | "children">

export const L2RButton = (props: L2RButtonProps) => {
    const {
        className,
        variant = "primary",
        size = "medium",
        shape = "rounded",
        disabled = false,
        outlined = true,
        children,
        ...buttonProps
    } = props

    const {
        color,
        onClick,
    } = buttonProps

    return (
        variant === "text" ?
            <Styled.TextButton
                className={className}
                type="button"
                disabled={disabled}
                buttonColor={color}
                buttonSize={size}
                onClick={onClick}>
                {children}
                <Styled.Underline className="TextButton-underline" buttonColor={color} />
            </Styled.TextButton> :
            shape === "rounded" ?
                <Styled.Button
                    className={className}
                    buttonVariant={variant}
                    buttonSize={size}
                    variant={variant === "tertiary" ? "outlined" : "contained"}
                    disabled={disabled}
                    disableElevation
                    onClick={onClick}
                    {...buttonProps}>
                    {children}
                </Styled.Button> :
                <Styled.IconButton
                    className={className}
                    buttonVariant={variant}
                    buttonShape={shape}
                    buttonSize={size}
                    disabled={disabled}
                    outlined={outlined}
                    onClick={onClick}>
                    {children}
                </Styled.IconButton>)
}